import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const LatestPosts = ({ title, posts = [], layoutType }) => {

    if (posts?.length === 0) {
        return <div>No posts available</div>;
    }

    const displayedPosts = posts?.length > 0 ? posts?.slice(0, 5) : [];
    const slicedPosts = displayedPosts?.length > 1 ? displayedPosts?.slice(1) : [];

    const getGridRows = () => {
        if (layoutType === 'two-images') {
            return 'grid-rows-2';
        }
        return 'grid-rows-2 grid-cols-2';
    };

    const imageVariants = {
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0 },
    };

    return (
        <section className="flex flex-col w-full max-md:max-w-full mt-0 lg:mt-10">
            <h2 className="self-start text-3xl font-extrabold leading-loose text-neutral-900">
                {title}
            </h2>
            <div className="grid grid-cols-2 gap-4 items-start  bg-blend-normal max-md:grid-cols-1 max-md:gap-y-8 max-md:max-w-full">
                {displayedPosts.length > 0 && (
                    <div className="relative w-full h-full">
                        <Link to={`/${displayedPosts[0]?.slug?.current}`}>
                            <motion.img
                                loading="lazy"
                                src={displayedPosts[0]?.mainImage?.asset?.url}
                                alt={displayedPosts[0]?.title}
                                className="object-cover w-full h-full rounded-2xl"
                                initial="initial"
                                animate="animate"
                                whileHover="hover"
                                variants={imageVariants}
                            />
                            <motion.div
                                className="absolute inset-0 bg-black bg-opacity-50 flex items-end justify-center rounded-2xl p-4"
                                initial="initial"
                                animate="animate"
                                whileHover="hover"
                                variants={imageVariants}
                            >
                                <h3 className="text-white text-lg teko w-[80%] md:text-xl lg:text-5xl leading-tight uppercase font-bold text-start pb-8 underline  decoration-[#09E9F0]">
                                    {displayedPosts[0]?.title}
                                </h3>
                            </motion.div>
                        </Link>
                    </div>
                )}

                <div className={`grid gap-6 ${getGridRows()} h-full`}>
                    {slicedPosts?.map((post, index) => (
                        <div key={index} className="relative w-full h-[340px] md:h-[300px]">
                            <Link to={`/${post?.slug?.current}`}>
                                <motion.img
                                    loading="lazy"
                                    src={post?.mainImage?.asset?.url}
                                    alt={post?.title}
                                    className="object-cover w-full h-full rounded-2xl"
                                    initial="initial"
                                    animate="animate"
                                    whileHover="hover"
                                    variants={imageVariants}
                                />
                                <motion.div
                                    className="absolute inset-0 bg-black bg-opacity-50 flex items-end justify-center rounded-2xl"
                                    initial="initial"
                                    animate="animate"
                                    whileHover="hover"
                                    variants={imageVariants}
                                >
                                    <h3 className="text-white text-lg teko w-[80%] md:text-xl lg:text-2xl leading-tight uppercase font-bold pb-8 text-start underline decoration-[#09E9F0]">
                                        {post?.title}
                                    </h3>
                                </motion.div>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default LatestPosts;
